import { CompanyUnits } from "../../../../../hooks/Remote/CompanyUnits/useRemoteFetchCompanyUnits";
import { IPlaceSchedule } from "../../../Domain/Types/FloorPlan/PlaceSchedule";
import { IZonePermission } from "../../../Domain/Types/FloorPlan/ZonePermission.type";

export function getMajorityDepartmentColor(
  places: IPlaceSchedule[],
  isConferenceRoom: boolean,
  permissions: IZonePermission[],
  departments: CompanyUnits[]
): string[] {
  // choose permission source based on isConferenceRoom
  const permissionSource = isConferenceRoom
    ? permissions
    : places.flatMap(p => p.permissions ?? []);

  // collect only records that have affected departments
  const validPermissionItems = permissionSource.filter(perm => perm.affectedDepartments?.length);

  if (validPermissionItems.length === 0) return [];

  const depCounts: Record<string, number> = {};

  // count department occurrences
  for (const perm of validPermissionItems) {
    const affectedIds = new Set(perm.affectedDepartments?.map(d => d.id).filter(Boolean));

    for (const id of affectedIds) {
      depCounts[id] = (depCounts[id] || 0) + 1;
    }
  }

  const threshold = validPermissionItems.length / 2;

  // return colors for departments meeting majority threshold
  return (
    Object.entries(depCounts)
      // when it's conference room, don't need to calculate majority of places
      .filter(([, count]) => (isConferenceRoom ? true : count >= threshold))
      .map(([id]) => departments.find(dep => dep.id === id)?.color)
      .filter(Boolean) as string[]
  );
}
